/**
 * PDP Shop the Look – slide-up size panel + AJAX add-to-cart
 */
document.addEventListener('DOMContentLoaded', function () {
  var section = document.querySelector('.pdp-shop-the-look');
  if (!section) return;

  var items = section.querySelectorAll('.stl-product-item');
  if (!items.length) return;

  /* ------------------------------------------------
   * Fetch current cart quantities for inventory checks
   * ------------------------------------------------ */
  function fetchCartQuantities() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = {};
        cart.items.forEach(function (item) {
          q[item.variant_id] = (q[item.variant_id] || 0) + item.quantity;
        });
        return q;
      })
      .catch(function () { return {}; });
  }

  fetchCartQuantities().then(function (cartQuantities) {

    items.forEach(function (item) {
      var trigger     = item.querySelector('.stl-select-trigger');
      var panel       = item.querySelector('.stl-size-panel');
      var backdrop    = item.querySelector('.stl-backdrop');
      var closeBtn    = item.querySelector('.stl-panel-close');
      var radios      = item.querySelectorAll('.stl-variant-option input[type="radio"]');
      var hiddenId    = item.querySelector('.stl-variant-id');
      var panelBtn    = item.querySelector('.stl-panel-add-btn');
      var notSelected = item.querySelector('.stl-not-selected');
      var triggerText = trigger ? trigger.textContent.trim() : '';

      function openPanel() {
        items.forEach(function (other) {
          if (other !== item) closeOtherPanel(other);
        });
        panel.classList.add('is-open');
        item.classList.add('panel-open');
      }

      function closePanel() {
        panel.classList.remove('is-open');
        item.classList.remove('panel-open');
      }

      function closeOtherPanel(otherItem) {
        var otherPanel = otherItem.querySelector('.stl-size-panel');
        if (otherPanel) otherPanel.classList.remove('is-open');
        otherItem.classList.remove('panel-open');
      }

      /* --- Desktop: size <select> change handler --- */
      var sizeSelect = item.querySelector('.stl-size-select');
      if (sizeSelect) {
        sizeSelect.addEventListener('change', function () {
          if (hiddenId) hiddenId.value = this.value;
          if (notSelected) notSelected.classList.remove('is-visible');
        });
      }

      /* --- Toggle panel (mobile trigger button) --- */
      if (trigger && panel) {
        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          if (panel.classList.contains('is-open')) {
            closePanel();
          } else {
            openPanel();
          }
        });
      }

      /* --- Close button inside panel --- */
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          closePanel();
        });
      }

      /* --- Close on backdrop click --- */
      if (backdrop) {
        backdrop.addEventListener('click', function () {
          closePanel();
        });
      }

      /* --- "TOEVOEGEN" button: opens panel on mobile, adds to cart on desktop --- */
      var addBtn = item.querySelector('.stl-add-btn');
      if (addBtn) {
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var isDesktop = window.innerWidth >= 990;

          if (isDesktop) {
            // Desktop: add to cart using the <select> value
            var selectedId = sizeSelect ? sizeSelect.value : null;
            if (!selectedId) {
              if (notSelected) {
                notSelected.classList.add('is-visible');
              }
              return;
            }
            addToCart(parseInt(selectedId), item, cartQuantities, function () {
              // Reset select after successful add
              if (sizeSelect) sizeSelect.selectedIndex = 0;
            });
          } else {
            // Mobile: toggle the slide-up panel
            if (panel) {
              if (panel.classList.contains('is-open')) {
                closePanel();
              } else {
                openPanel();
              }
            }
          }
        });
      }

      /* --- Variant selection --- */
      radios.forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (hiddenId) hiddenId.value = this.value;

          // Update trigger text with selected size
          if (trigger) {
            var label = this.nextElementSibling ? this.nextElementSibling.textContent.trim() : '';
            trigger.textContent = label ? label : triggerText;
          }

          if (notSelected) notSelected.classList.remove('is-visible');

          updatePanelButton(item, cartQuantities);
        });
      });

      /* --- Add to cart (mobile panel button) --- */
      if (panelBtn) {
        panelBtn.addEventListener('click', function (e) {
          e.preventDefault();

          var selected = item.querySelector('.stl-variant-option input:checked');

          if (!selected) {
            if (notSelected) notSelected.classList.add('is-visible');
            return;
          }

          addToCart(parseInt(selected.value), item, cartQuantities, function () {
            // Close panel & reset
            closePanel();
            if (trigger) trigger.textContent = triggerText;
            radios.forEach(function (r) { r.checked = false; });
          });
        });
      }
    });
  });

  /* ------------------------------------------------
   * Shared add-to-cart function (desktop + mobile)
   * ------------------------------------------------ */
  function addToCart(variantId, itemEl, cartQuantities, onSuccess) {
    var notSelected = itemEl.querySelector('.stl-not-selected');
    var activeBtn   = itemEl.querySelector('.stl-panel-add-btn:not([style*="display: none"])') || itemEl.querySelector('.stl-add-btn');

    // Find inventory data from either the <select> option or the radio input
    var optionEl = itemEl.querySelector('.stl-size-select option[value="' + variantId + '"]')
                || itemEl.querySelector('.stl-variant-option input[value="' + variantId + '"]');

    var inventoryQty        = optionEl ? parseInt(optionEl.dataset.inventoryQuantity) || 0 : 0;
    var inventoryManagement = optionEl ? optionEl.dataset.inventoryManagement : '';
    var inventoryPolicy     = optionEl ? optionEl.dataset.inventoryPolicy : '';
    var cartQty             = cartQuantities[variantId] || 0;

    // Inventory check
    if (inventoryManagement === 'shopify' && inventoryPolicy !== 'continue') {
      if (inventoryQty - cartQty <= 0) {
        if (notSelected) {
          notSelected.textContent = cartQty > 0
            ? 'Dit product zit al in je winkelwagen'
            : 'Uitverkocht';
          notSelected.classList.add('is-visible');
        }
        return;
      }
    }

    // Disable button
    if (activeBtn) {
      activeBtn.disabled = true;
      activeBtn.classList.add('disabled');
    }

    // Detect cart element (cart-drawer or cart-notification)
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionsToRender = cart && typeof cart.getSectionsToRender === 'function'
      ? cart.getSectionsToRender().map(function (s) { return s.id; }).join(',')
      : 'cart-drawer,cart-icon-bubble';

    var body = {
      items: [{ id: variantId, quantity: 1 }],
      sections: sectionsToRender,
      sections_url: window.location.pathname
    };

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    })
    .then(function (response) { return response.json(); })
    .then(function (data) {
      if (data.status) {
        // Error from Shopify (e.g. out of stock)
        if (notSelected) {
          notSelected.textContent = data.description || 'Er is iets misgegaan.';
          notSelected.classList.add('is-visible');
        }
        return;
      }

      cartQuantities[variantId] = (cartQuantities[variantId] || 0) + 1;

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: data
      }));

      // Render cart contents (works for both cart-drawer and cart-notification)
      if (cart && typeof cart.renderContents === 'function') {
        cart.renderContents(data);
      } else {
        window.location = window.routes.cart_url;
      }

      if (typeof onSuccess === 'function') onSuccess();
    })
    .catch(function (err) {
      console.error('Shop the Look – add to cart error:', err);
      if (notSelected) {
        notSelected.textContent = 'Er is iets misgegaan. Probeer het opnieuw.';
        notSelected.classList.add('is-visible');
      }
    })
    .finally(function () {
      if (activeBtn) {
        activeBtn.disabled = false;
        activeBtn.classList.remove('disabled');
      }
    });
  }

  /* --- Close panels on outside click --- */
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.stl-product-item')) {
      section.querySelectorAll('.stl-size-panel.is-open').forEach(function (p) {
        p.classList.remove('is-open');
      });
      section.querySelectorAll('.stl-product-item.panel-open').forEach(function (el) {
        el.classList.remove('panel-open');
      });
    }
  });

  function updatePanelButton(item, cartQuantities) {
    var selected = item.querySelector('.stl-variant-option input:checked');
    var panelBtn = item.querySelector('.stl-panel-add-btn');
    if (!selected || !panelBtn) return;

    var variantId           = parseInt(selected.value);
    var inventoryQty        = parseInt(selected.dataset.inventoryQuantity) || 0;
    var inventoryManagement = selected.dataset.inventoryManagement;
    var inventoryPolicy     = selected.dataset.inventoryPolicy;
    var cartQty             = cartQuantities[variantId] || 0;

    if (inventoryManagement === 'shopify' && inventoryPolicy !== 'continue' && (inventoryQty - cartQty) <= 0) {
      panelBtn.classList.add('disabled');
      panelBtn.disabled = true;
    } else {
      panelBtn.classList.remove('disabled');
      panelBtn.disabled = false;
    }
  }
});
